import type { BoxInfo } from '@lub0v/santa-utils';
import { useTranslation } from 'react-i18next';
import { pushDialog } from '@src/components/Dialog/Dialog';
import { useDuplicateGameDialog } from '@src/pages/BoxesPage/DuplicateGameDialog';

/** Handle only the server's creation-window rejection; leave other errors with their caller. */
export function useBoxRenewalError(info: BoxInfo) {
  const { t } = useTranslation();
  const copy = useDuplicateGameDialog('game_settings');
  return (message?: string | null): boolean => {
    if (message !== 'game.renewal.required') return false;
    // Keep the originating editor and its draft when dismissing this prompt.
    pushDialog({
      title: t('game.renewal.title'),
      testId: 'game-renewal-dialog',
      children: <p>{t(info.isAdmin ? 'game.renewal.required' : 'game.renewal.participant')}</p>,
      submit: info.isAdmin ? t('game.renewal.copy') : undefined,
      onSubmit: info.isAdmin ? () => { copy(info); } : undefined,
      cancel: t('box.close'),
    });
    return true;
  };
}
